const cocktail = {
  enable() {
    const closes = Array.from(document.querySelectorAll(cocktail.ui.selectors.closes))
    const filters = Array.from(document.querySelectorAll(cocktail.ui.selectors.filters))
    const items = Array.from(document.querySelectorAll(cocktail.ui.selectors.items))
    const next = Array.from(document.querySelectorAll(cocktail.ui.selectors.overlayNext))
    const prev = Array.from(document.querySelectorAll(cocktail.ui.selectors.overlayPrev))

    closes.map(close => close.addEventListener('click', cocktail.setOverlayDisable))
    filters.map(filter => filter.addEventListener('click', cocktail.setItemFilter))

    items.map(item =>
      item.addEventListener('click', (e) => {
        e.preventDefault()

        cocktail.setOverlayContent(e.currentTarget)

        setTimeout(() => {
          cocktail.setOverlayActive(e)
        }, 100)
      }))

    next.map(nxt => nxt.addEventListener('click', cocktail.setOverlayNext))
    prev.map(prv => prv.addEventListener('click', cocktail.setOverlayPrev))
  },

  setItemFilter(e) {
    e.preventDefault()
    const items = Array.from(document.querySelectorAll(cocktail.ui.selectors.items))
    const filters = Array.from(document.querySelectorAll(cocktail.ui.selectors.filters))
    const filterKey = e.currentTarget.textContent

    filters.map((filter) => {
      filter.classList.remove('s-cocktail__filter-link--active')
    })

    e.currentTarget.classList.add('s-cocktail__filter-link--active')

    items.map((item) => {
      const itm = item
      const tags = itm.dataset.tags.split(',')

      if (tags.includes(filterKey)) {
        itm.style.display = 'block'
      } else {
        itm.style.display = 'none'
      }
    })
  },

  setOverlayActive(e) {
    e.preventDefault()

    const overlay = document.querySelector(cocktail.ui.selectors.overlay)

    if (overlay) {
      overlay.classList.add(cocktail.ui.classes.opacityActive)
      overlay.classList.add(cocktail.ui.classes.slideActive)
      overlay.style.zIndex = 15
    }
  },

  setOverlayContent(item) {
    const itemCopy = item.querySelector(cocktail.ui.selectors.itemCopy)
    const itemDownloads = item.querySelector(cocktail.ui.selectors.itemDownloads)
    const itemImage = item.querySelector(cocktail.ui.selectors.itemImage)
    const itemTitle = item.querySelector(cocktail.ui.selectors.itemTitle)
    const overlay = document.querySelector(cocktail.ui.selectors.overlay)
    const overlayContentWrapper = document.querySelector(cocktail.ui.selectors.overlayContentWrapper)
    const overlayCopy = document.querySelector(cocktail.ui.selectors.overlayCopy)
    const overlayImageCurrent = document.querySelector(cocktail.ui.selectors.overlayImageCurrent)
    const overlayImageOld = document.querySelector(cocktail.ui.selectors.overlayImageOld)
    const overlayTitle = document.querySelector(cocktail.ui.selectors.overlayTitle)

    const tags = item.dataset.tags.split(',')

    if (tags.includes('garden')) {
      overlay.classList.add('s-cocktail__overlay--garden')
    }

    if (tags.includes('spice')) {
      overlay.classList.add('s-cocktail__overlay--spice')
    }

    if (overlay) {
      overlay.classList.add(cocktail.ui.classes.transitioning)

      if (overlayImageCurrent && overlayImageOld) {
        overlayImageOld.src = overlayImageCurrent.src
      }

      setTimeout(() => {
        if (overlayCopy && itemCopy) {
          overlayCopy.innerHTML = itemCopy.innerHTML
        }

        if (overlayContentWrapper && itemDownloads) {
          if (overlayContentWrapper.lastElementChild.tagName === 'A') {
            overlayContentWrapper.removeChild(overlayContentWrapper.lastElementChild)
          }

          overlayContentWrapper.insertAdjacentHTML('beforeend', itemDownloads.innerHTML)
        }

        if (overlayImageCurrent && overlayImageOld && itemImage) {
          overlayImageOld.src = overlayImageCurrent.src
          overlayImageCurrent.src = itemImage.src.replace('_grande', '')
        }

        if (overlayTitle && itemTitle) {
          overlayTitle.innerHTML = itemTitle.innerHTML
        }

        if (item.dataset) {
          overlay.dataset.index = item.dataset.index
        }

        overlay.classList.remove(cocktail.ui.classes.transitioning)
      }, 280)
    }
  },

  setOverlayDisable(e) {
    if (e.target !== e.currentTarget) return

    e.preventDefault()

    const overlay = document.querySelector(cocktail.ui.selectors.overlay)

    delete overlay.dataset.index

    overlay.classList.remove(cocktail.ui.classes.slideActive)

    setTimeout(() => {
      overlay.classList.remove(cocktail.ui.classes.opacityActive)
      overlay.classList.remove('s-cocktail__overlay--garden')
      overlay.classList.remove('s-cocktail__overlay--spice')
    }, 280)

    setTimeout(() => {
      overlay.style.zIndex = -1
    }, 420)
  },

  setOverlayNext(e) {
    e.preventDefault()

    // get current index from overlay
    const overlay = document.querySelector(cocktail.ui.selectors.overlay)
    const currentIndexOverlay = parseInt(overlay.dataset.index, 10)

    // get current element
    const currentElement = document.querySelector(`.s-cocktail__item[data-index="${currentIndexOverlay}"]`)

    // array of non hidden items
    const nonHiddenElements = Array.from(document.querySelectorAll(cocktail.ui.selectors.itemsNotHidden))

    // first non hidden item
    let targetElement = nonHiddenElements[0]

    // index of current item in new array
    const currentIndexInNewArray = nonHiddenElements.indexOf(currentElement)

    // next item in array
    const nextElement = nonHiddenElements[currentIndexInNewArray + 1]

    // if next elm exists, store it, otherwise go with default (first)
    if (nextElement) {
      targetElement = nextElement
    }

    // set content
    cocktail.setOverlayContent(targetElement)
  },

  setOverlayPrev(e) {
    e.preventDefault()

    // get current index from overlay
    const overlay = document.querySelector(cocktail.ui.selectors.overlay)
    const currentIndexOverlay = parseInt(overlay.dataset.index, 10)

    // get current element
    const currentElement = document.querySelector(`.s-cocktail__item[data-index="${currentIndexOverlay}"]`)

    // array of non hidden items
    const nonHiddenElements = Array.from(document.querySelectorAll(cocktail.ui.selectors.itemsNotHidden))

    // last non hidden item
    let targetElement = nonHiddenElements[nonHiddenElements.length - 1]

    // index of current item in new array
    const currentIndexInNewArray = nonHiddenElements.indexOf(currentElement)

    // next item in array
    const prevElement = nonHiddenElements[currentIndexInNewArray - 1]

    // if prev elm exists, store it, otherwise go with default (last)
    if (prevElement) {
      targetElement = prevElement
    }

    // set content
    cocktail.setOverlayContent(targetElement)
  },

  ui: {
    classes: {
      opacityActive: 's-cocktail__overlay--opacity-active',
      slideActive: 's-cocktail__overlay--slide-active',
      transitioning: 's-cocktail__overlay--transitioning',
    },
    selectors: {
      closes: '.s-cocktail__overlay-close, .s-cocktail__overlay',
      filters: '.s-cocktail__filter-link',
      itemCopy: '.s-cocktail__copy',
      itemDownloads: '.s-cocktail__downloads',
      itemImage: '.s-cocktail__image',
      items: '.s-cocktail__item',
      itemsNotHidden: '.s-cocktail__item:not([style="display: none;"])',
      itemTitle: '.s-cocktail__link',
      overlay: '.s-cocktail__overlay',
      overlayContentWrapper: '.s-cocktail__overlay-content-wrapper',
      overlayCopy: '.s-cocktail__overlay-copy',
      overlayImageCurrent: '.s-cocktail__overlay-image--current',
      overlayImageOld: '.s-cocktail__overlay-image--old',
      overlayNext: '.s-cocktail__overlay-next .s-cocktail__overlay-link',
      overlayPrev: '.s-cocktail__overlay-prev .s-cocktail__overlay-link',
      overlayTitle: '.s-cocktail__overlay-title',
    },
  },
}

export default { enable: cocktail.enable }
